// French for the Agent page: the instrument line, the dispatch deck and scope picker, the pass
// in flight, the run ledger and its expansion, the corpus dock, the delete modal. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── the instrument line ──
  'The execution plane is down.': 'Le plan d’exécution est hors service.',
  'vLLM at': 'vLLM à',
  'did not answer.': 'n’a pas répondu.',
  'The endpoint said: “{error}”.': 'Le point de terminaison a répondu : «{error}».',
  'Nothing can be dispatched — every pass below would die at its first turn. The register stays fully usable by hand.':
    'Rien ne peut être lancé — chaque passe ci-dessous mourrait à son premier tour. Le registre reste entièrement utilisable à la main.',
  'Re-check': 'Revérifier',
  'Ready': 'Prêt',
  'Checking…': 'Vérification…',
  'no model reported': 'aucun modèle signalé',
  'workspace': 'Workspace',
  'docs at': 'documents à',
  'built automatically when the first run starts': 'construit automatiquement au démarrage de la première exécution',
  'of': 'sur',
  'slots in use': 'slots occupés',
  'this run stops after': 'cette exécution s’arrête après',
  'min': 'min',
  'or': 'ou',
  'turns': 'tours',
  'both run slots free': 'les deux slots d’exécution libres',
  '{n} run slots free': '{n} slots d’exécution libres',
  'Rebuilding…': 'Reconstruction…',
  'Rebuild workspace': 'Reconstruire le workspace',

  // ── the deck ──
  'vLLM is unreachable — the run would die at its first turn.': 'vLLM est injoignable — l’exécution mourrait dès son premier tour.',
  'Two runs are already live.': 'Deux exécutions sont déjà actives.',
  'since': 'depuis',
  'linked': 'lié',
  'uncovered': 'non couvert',
  'armed': 'armé',
  '+{n} more': '+{n} de plus',
  'no subject': 'aucun objet',
  'Operator note for this pass — it travels into the prompt': 'Note de l’opérateur pour cette passe — elle voyage jusque dans le prompt',
  'Dispatch': 'Lancer',

  // ── the scope picker ──
  'Choose documents': 'Choisir des documents',
  'selected': 'sélectionnés',
  'All': 'Tous',
  'Not yet covered ({n})': 'Pas encore couverts ({n})',
  'None': 'Aucun',
  'Close': 'Fermer',
  'No document is linked to this engagement, so a batch pass would have nothing to read.':
    'Aucun document n’est lié à ce mandat, une passe batch n’aurait donc rien à lire.',
  'no text layer': 'aucune couche de texte',
  'covered': 'couvert',
  'not yet covered': 'pas encore couvert',
  'Optional instruction — with one, this runs as a targeted pass instead of a batch pass':
    'Instruction facultative — avec une instruction, ceci s’exécute comme une passe ciblée plutôt qu’une passe batch',
  'Starting…': 'Démarrage…',
  'Start targeted run': 'Lancer une exécution ciblée',
  'Start batch run ({n} docs)': 'Lancer une exécution batch ({n} doc.)',

  // ── the pass in flight ──
  'running': 'en cours',
  'tool calls': 'appels d’outils',
  'Stop': 'Arrêter',
  'documents in scope accounted for.': 'documents du périmètre pris en compte.',
  'A run ends only when': 'Une exécution ne se termine que lorsque',
  'accepts an account naming every one of them.': 'accepte un bilan nommant chacun d’entre eux.',
  'This run carries no close discipline, so it ends on its own prose.':
    'Cette exécution ne porte aucune discipline de clôture, elle se termine donc sur sa propre prose.',
  '{proposals}, {questions} from {ref}': '{proposals}, {questions} depuis {ref}',
  '{n} proposal': '{n} proposition',
  '{n} proposals': '{n} propositions',
  '{n} question': '{n} question',
  '{n} questions': '{n} questions',
  'nothing filed from {ref} yet': 'rien n’a encore été déposé depuis {ref}',
  'This pass walks the register rather than a document set, so there is no per-document tally — watch what it files.':
    'Cette passe parcourt le registre plutôt qu’un ensemble de documents, il n’y a donc pas de décompte par document — observez ce qu’elle dépose.',
  'Filed so far — {proposals}, {questions}': 'Déposé jusqu’ici — {proposals}, {questions}',
  'no document cited': 'aucun document cité',
  'Nothing filed yet. Statements appear here the moment they reach the database.':
    'Rien n’a encore été déposé. Les déclarations apparaissent ici dès qu’elles atteignent la base de données.',
  'Nudge — the agent reads this at its next turn boundary': 'Relance — l’agent la lit à sa prochaine limite de tour',
  'Nudge': 'Relancer',

  // ── the verdict (one run = one sentence) ──
  'scope': 'périmètre',
  'document': 'document',
  'documents': 'documents',
  'read': 'lus',
  'walked the register': 'a parcouru le registre',
  'in scope': 'dans le périmètre',
  'turns with you': 'tours avec vous',
  'no close discipline': 'aucune discipline de clôture',
  'claimed': 'revendiqué',
  'filed,': 'déposé,',
  'on record': 'consigné',
  'held': 'retenu',
  'rejected': 'refusé',
  'waiting on you': 'vous attendent',
  'filed': 'déposé',
  'recorded': 'enregistré',
  'fact': 'fait',
  'facts': 'faits',
  'event': 'événement',
  'events': 'événements',

  // ── the closing account ──
  'The account it closed on': 'Le bilan sur lequel elle s’est clôturée',
  'No closing account.': 'Aucun bilan de clôture.',
  'This pass carried a close discipline and never satisfied it, so there is no statement of what it did — only the transcript.':
    'Cette passe portait une discipline de clôture et ne l’a jamais satisfaite, il n’y a donc aucune déclaration de ce qu’elle a fait — seulement la transcription.',
  'A conversation and a plain targeted run end on their own prose; there is nothing to validate.':
    'Une conversation et une simple exécution ciblée se terminent sur leur propre prose ; il n’y a rien à vérifier.',
  'Showing the whole account.': 'Le bilan complet est affiché.',
  'Showing the head of the account — {shown} of {total} lines.': 'Le début du bilan est affiché — {shown} sur {total} lignes.',
  'Show the head': 'Afficher le début',
  'Full account': 'Bilan complet',

  // ── the filed statements ──
  'pending review': 'en attente de vérification',
  'rejected — {reason}': 'refusé — {reason}',
  'no reason recorded': 'aucun motif consigné',
  'accepted with edits': 'accepté avec modifications',
  'superseded': 'remplacé',
  'accepted‖proposal': 'retenu',
  'What it filed': 'Ce qu’elle a déposé',
  'Every statement carries the span it was taken from.': 'Chaque déclaration porte l’extrait source dont elle est tirée.',
  '(no text recorded)': '(aucun texte enregistré)',
  'proposal #{id}': 'proposition #{id}',
  'Definition of done': 'Critères d’acceptation',
  'document #{id}': 'document #{id}',

  // ── the transcript ──
  'Transcript': 'Transcription',
  'No transcript was captured for this run.': 'Aucune transcription n’a été capturée pour cette exécution.',
  'Transcript — the provenance record': 'Transcription — l’enregistrement de provenance',
  'Every pushback the tool layer gave, in the words it gave them.': 'Chaque rejet de la couche d’outils, dans les mots où elle les a formulés.',
  'The pass prompt it was given — in full under Provenance, below.': 'Le prompt de la passe qu’elle a reçu — intégralement sous Provenance, ci-dessous.',
  'You / the continuation': 'Vous / la suite',
  'pushed back': 'rejeté',
  'missed': 'manqué',
  'ok': 'ok',

  // ── the run expansion / provenance ──
  'Could not read the run': 'L’exécution n’a pas pu être lue',
  'This run could not be read': 'Cette exécution n’a pas pu être lue',
  'Reading the run…': 'Lecture de l’exécution…',
  'Provenance': 'Provenance',
  'model': 'modèle',
  'skills': 'Skills',
  'config': 'configuration',
  'tokens in': 'tokens en entrée',
  'out': 'sortie',
  'lookup misses': 'recherches infructueuses',
  'ordinary searching, not pushbacks': 'recherche ordinaire, pas des rejets',
  'scope:': 'périmètre :',
  'Hide the prompt it was given': 'Masquer le prompt reçu',
  'The prompt it was given': 'Le prompt reçu',
  'Open this thread': 'Ouvrir ce thread',
  'Delete run': 'Supprimer l’exécution',

  // ── acts / toasts ──
  'Run #{id} dispatched over {n} document': 'Exécution #{id} lancée sur {n} document',
  'Run #{id} dispatched over {n} documents': 'Exécution #{id} lancée sur {n} documents',
  '{label} started — proposals land in the review queue': '{label} lancée — les propositions atterrissent dans la file d’attente',
  'Could not dispatch the pass': 'La passe n’a pas pu être lancée',
  'Run #{id} queued': 'Exécution #{id} mise en file',
  'Could not start the run': 'L’exécution n’a pas pu être lancée',
  'Run #{id} stopped': 'Exécution #{id} arrêtée',
  'Could not stop the run': 'L’exécution n’a pas pu être arrêtée',
  'Nudge queued — the agent reads it at its next turn boundary': 'Relance mise en file — l’agent la lit à sa prochaine limite de tour',
  'Nudge failed': 'Échec de la relance',
  'Workspace committed {sha}': 'Workspace committé {sha}',
  'Workspace refresh failed': 'Échec de l’actualisation du workspace',
  'Run #{id} deleted — {n} proposal kept': 'Exécution #{id} supprimée — {n} proposition conservée',
  'Run #{id} deleted — {n} proposals kept': 'Exécution #{id} supprimée — {n} propositions conservées',
  'Run #{id} deleted': 'Exécution #{id} supprimée',
  'Could not delete the run': 'L’exécution n’a pas pu être supprimée',
  'Cleared {n} run': '{n} exécution nettoyée',
  'Cleared {n} runs': '{n} exécutions nettoyées',
  '{cleared} — kept {n} that produced proposals': '{cleared} — {n} conservées, ayant produit des propositions',
  'Nothing to clear — every finished run produced proposals': 'Rien à nettoyer — chaque exécution terminée a produit des propositions',
  'Cleanup failed': 'Échec du nettoyage',
  'Could not open that thread': 'Ce thread n’a pas pu être ouvert',
  '(no text in the reply — open the run below for its transcript)': '(aucun texte dans la réponse — ouvrez l’exécution ci-dessous pour sa transcription)',
  'proposal #{id} · {kind}': 'proposition #{id} · {kind}',
  'Failed': 'Échec',
  '⏹ Stopped by you. The thread is kept — ask again to carry on.': '⏹ Arrêté par vous. Le thread est conservé — posez à nouveau une question pour poursuivre.',

  // ── masthead / no engagement ──
  'Agent': 'Agent',
  'no engagement selected': 'aucun mandat sélectionné',
  'Extraction is always scoped to one engagement': 'L’extraction est toujours limitée à un seul mandat',
  "A run reads that engagement's linked documents and files into its register. Pick an engagement in the top bar and its desk loads here.":
    'Une exécution lit les documents liés à ce mandat et les dépose dans son registre. Choisissez un mandat dans la barre du haut, et son desk se charge ici.',
  'Extraction against': 'Extraction sur',
  'in-scope requirements': 'exigences dans le périmètre',
  'still draft': 'encore brouillon',

  // ── zone 1 — the desk ──
  'In flight': 'En cours',
  'Polled every 5 s. What you see below is what it has already': 'Interrogé toutes les 5 s. Ce que vous voyez ci-dessous est ce qu’elle a déjà',
  ', not what it says.': ', pas ce qu’elle dit.',
  'Each card names the gap it closes and the refs it would touch. Everything lands in the review queue; no pass writes to the register.':
    'Chaque carte nomme la lacune qu’elle comble et les refs qu’elle toucherait. Tout atterrit dans la file d’attente ; aucune passe n’écrit dans le registre.',
  'The dispatch deck': 'Le Deck de lancement',
  'Reading the register for the gaps a pass would close…': 'Lecture du registre à la recherche des lacunes qu’une passe comblerait…',
  'Something else in scope?': 'Autre chose dans le périmètre ?',
  'Choose documents…': 'Choisir des documents…',

  // ── zone 2 — the ledger ──
  'Runs — the account each one gave of itself': 'Exécutions — le bilan que chacune a donné d’elle-même',
  'Newest first. Open a run for its closing account and its transcript.': 'Les plus récentes d’abord. Ouvrez une exécution pour son bilan de clôture et sa transcription.',
  'The standing fault.': 'Le défaut persistant.',
  'of the': 'sur les',
  'tool pushbacks across every run on this engagement are one thing —': 'rejets d’outils sur toutes les exécutions de ce mandat sont une seule et même chose —',
  'At review,': 'À la vérification,',
  'rejections you made were': 'refus que vous avez faits étaient',
  'Both point at the same prompt work, not at a bad run.': 'Les deux pointent vers le même travail de prompt, pas vers une mauvaise exécution.',
  'The fault classes': 'Les classes de défaut',
  'The run ledger': 'Le journal des exécutions',
  'Reading the ledger…': 'Lecture du journal…',
  'No run has been dispatched on this engagement': 'Aucune exécution n’a été lancée sur ce mandat',
  'A batch pass would read the {n} linked document above and file what it finds into the review queue. Nothing it files reaches the register until you accept it.':
    'Une passe batch lirait le {n} document lié ci-dessus et déposerait ses trouvailles dans la file d’attente. Rien de ce qu’elle dépose n’atteint le registre tant que vous ne l’avez pas retenu.',
  'A batch pass would read the {n} linked documents above and file what it finds into the review queue. Nothing it files reaches the register until you accept it.':
    'Une passe batch lirait les {n} documents liés ci-dessus et déposerait ses trouvailles dans la file d’attente. Rien de ce qu’elle dépose n’atteint le registre tant que vous ne l’avez pas retenu.',
  'Review {n} →': 'Vérifier {n} →',
  '{n} finished run produced nothing — no proposal, no fact, no claim of either.':
    '{n} exécution terminée n’a rien produit — aucune proposition, aucun fait, aucune affirmation de l’un ou l’autre.',
  '{n} finished runs produced nothing — no proposal, no fact, no claim of either.':
    '{n} exécutions terminées n’ont rien produit — aucune proposition, aucun fait, aucune affirmation de l’un ou l’autre.',
  'Clear them': 'Nettoyer',

  // ── zone 3 — the corpus dock ──
  'Ask the corpus': 'Interroger le corpus',
  'Anything the agent records here lands in the same review queue.': 'Tout ce que l’agent enregistre ici atterrit dans la même file d’attente.',
  'Close the thread': 'Fermer le thread',
  'Open the thread': 'Ouvrir le thread',
  'Thread': 'Thread',
  'is open.': 'est ouvert.',
  'Last thread': 'Dernier thread',
  '{proposals}, {held} held. Idle since {since}.': '{proposals}, {held} retenues. Inactif depuis {since}.',
  'No thread yet. Ask about the corpus — “which documents mention OCR?”': 'Pas encore de thread. Interrogez le corpus — «quels documents mentionnent l’OCR ?»',
  'Ask about the corpus — “what did the sponsor say about the data room?”, “which documents mention OCR?”. Anything the agent proposes lands in the review queue, never in the register.':
    'Interrogez le corpus — «qu’a dit le sponsor à propos de la data room ?», «quels documents mentionnent l’OCR ?». Tout ce que l’agent propose atterrit dans la file d’attente, jamais dans le registre.',
  'You': 'Vous',
  'thinking…': 'réflexion…',
  'Ask the corpus…': 'Interroger le corpus…',
  'vLLM is unreachable — the turn would die immediately.': 'vLLM est injoignable — le tour mourrait immédiatement.',
  'Send': 'Envoyer',
  'Start a new thread — the current one stays in the ledger': 'Démarrer un nouveau thread — l’actuel reste dans le journal',
  'New thread': 'Nouveau thread',

  // ── the delete modal ──
  'Delete run #{id}?': 'Supprimer l’exécution #{id} ?',
  'Delete': 'Supprimer',
  'This removes the run and its transcript for good.': 'Cela supprime définitivement l’exécution et sa transcription.',
  'Its': 'Ses',
  'proposal(s) are kept — they keep their statement and evidence, but lose the link back to this transcript, so “why did it think that?” can no longer be answered by reading the run.':
    'proposition(s) sont conservées — elles gardent leur déclaration et leur preuve, mais perdent le lien vers cette transcription, de sorte que «pourquoi pensait-elle cela ?» ne peut plus trouver de réponse en lisant l’exécution.',
  'It produced no proposals, so nothing else is affected.': 'Elle n’a produit aucune proposition, rien d’autre n’est donc affecté.',
  'The deletion itself is recorded in the audit log.': 'La suppression elle-même est consignée dans la piste d’audit.',

  // ── the two faces (Desk | Proposals — the queue folded in as a sub-tab) ──
  'Desk': 'Desk',
  'Proposals': 'Propositions',
}, 'AgentPage');
